import { render, staticRenderFns } from "./Leadforms.vue?vue&type=template&id=81495bea"
import script from "./Leadforms.vue?vue&type=script&lang=js"
export * from "./Leadforms.vue?vue&type=script&lang=js"
import style0 from "./Leadforms.vue?vue&type=style&index=0&id=81495bea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports